// extracted by mini-css-extract-plugin
export var label = "_ak-5";
export var slideContainer = "_ak-0";
export var slider = "_ak-1";
export var sliderLg = "_ak-4";
export var sliderMd = "_ak-3";
export var sliderSm = "_ak-2";